function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.47636 3.91934V11.132C6.47636 12.5568 5.43333 13.8248 4.01534 13.9611C2.38603 14.1179 1.02258 12.8431 1.02258 11.2479V2.82176C1.02258 1.92871 1.6634 1.11746 2.54964 1.02883C3.57222 0.926576 4.43119 1.72419 4.43119 2.72632V9.88441C4.43119 10.2594 4.12442 10.5661 3.74947 10.5661C3.37452 10.5661 3.06775 10.2594 3.06775 9.88441V3.91934C3.06775 3.63983 2.83596 3.40804 2.55646 3.40804C2.27695 3.40804 2.04517 3.63983 2.04517 3.91934V9.78896C2.04517 10.682 2.68599 11.4933 3.57222 11.5819C4.59481 11.6842 5.45378 10.8865 5.45378 9.88441V2.84222C5.45378 1.41742 4.41074 0.149413 2.99276 0.0130682C1.37026 -0.143728 0 1.13109 0 2.72632V11.0911C0 13.0476 1.43162 14.7996 3.38134 14.9837C5.62421 15.1882 7.49894 13.443 7.49894 11.2479V3.91934C7.49894 3.63983 7.26716 3.40804 6.98765 3.40804C6.70815 3.40804 6.47636 3.63983 6.47636 3.91934Z",
  stroke: "none",
  fill: "inherit"
});

var SvgClip = function SvgClip(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 15",
    fill: "currentColor",
    stroke: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clip.715a4874.svg";
export { ForwardRef as ReactComponent };